import { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import LanguageToggle from '../../../components/feature/LanguageToggle';

export default function Navbar() {
  const { t } = useTranslation();
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
      setIsMobileMenuOpen(false);
    }
  };

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled ? 'bg-white shadow-md' : 'bg-transparent'
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 py-4">
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-4">
            <img
              src="https://public.readdy.ai/ai/img_res/38649e02-2eb9-4d52-9903-8373f3d01723.png"
              alt="MYSA Logo"
              className="h-14 w-auto"
            />
          </div>
          
          {/* Center MYSA Text Logo */}
          <div className="absolute left-1/2 transform -translate-x-1/2 flex items-center h-14">
            <button
              onClick={() => scrollToSection('home')}
              className="cursor-pointer"
            >
              <img
                src="https://public.readdy.ai/ai/img_res/b5c307e1-6a50-4135-97a5-c1c35bc0af70.png"
                alt="MYSA"
                className="h-8 w-auto"
              />
            </button>
          </div>

          {/* Desktop Menu */}
          <div className="hidden md:flex items-center space-x-8">
            <button
              onClick={() => scrollToSection('mysa-products')}
              className={`text-sm font-medium transition-colors whitespace-nowrap ${
                isScrolled ? 'text-gray-700 hover:text-red-600' : 'text-white hover:text-red-200'
              }`}
            >
              {t('nav.products')}
            </button>
            <button
              onClick={() => scrollToSection('features')}
              className={`text-sm font-medium transition-colors whitespace-nowrap ${
                isScrolled ? 'text-gray-700 hover:text-red-600' : 'text-white hover:text-red-200'
              }`}
            >
              {t('nav.features')}
            </button>
            <button
              onClick={() => scrollToSection('pricing')}
              className={`text-sm font-medium transition-colors whitespace-nowrap ${
                isScrolled ? 'text-gray-700 hover:text-red-600' : 'text-white hover:text-red-200'
              }`}
            >
              {t('nav.pricing')}
            </button>
            <button
              onClick={() => scrollToSection('contact')}
              className={`text-sm font-medium transition-colors whitespace-nowrap ${
                isScrolled ? 'text-gray-700 hover:text-red-600' : 'text-white hover:text-red-200'
              }`}
            >
              {t('nav.contact')}
            </button>
            <button
              onClick={() => scrollToSection('order')}
              className="bg-red-600 text-white px-6 py-2 rounded-full text-sm font-medium hover:bg-red-700 transition-colors whitespace-nowrap"
            >
              {t('nav.orderNow')}
            </button>
            <LanguageToggle isScrolled={isScrolled} />
          </div>

          {/* Mobile Menu Button & Language Toggle */}
          <div className="md:hidden flex items-center gap-2">
            <LanguageToggle isScrolled={isScrolled} />
            <button
              onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
              className={`p-2 rounded-lg transition-colors cursor-pointer ${
                isScrolled ? 'text-gray-700 hover:bg-gray-100' : 'text-white hover:bg-white/10'
              }`}
            >
              <i className={`${isMobileMenuOpen ? 'ri-close-line' : 'ri-menu-line'} text-2xl`}></i>
            </button>
          </div>
        </div>

        {/* Mobile Menu */}
        {isMobileMenuOpen && (
          <div className={`md:hidden mt-4 pb-4 ${isScrolled ? 'bg-white' : 'bg-black/20 backdrop-blur-md'} rounded-lg`}>
            <div className="flex flex-col space-y-3 px-4">
              <button
                onClick={() => scrollToSection('mysa-products')}
                className={`text-sm font-medium transition-colors text-left py-2 whitespace-nowrap ${
                  isScrolled ? 'text-gray-700 hover:text-red-600' : 'text-white hover:text-red-200'
                }`}
              >
                {t('nav.products')}
              </button>
              <button
                onClick={() => scrollToSection('features')}
                className={`text-sm font-medium transition-colors text-left py-2 whitespace-nowrap ${
                  isScrolled ? 'text-gray-700 hover:text-red-600' : 'text-white hover:text-red-200'
                }`}
              >
                {t('nav.features')}
              </button>
              <button
                onClick={() => scrollToSection('pricing')}
                className={`text-sm font-medium transition-colors text-left py-2 whitespace-nowrap ${
                  isScrolled ? 'text-gray-700 hover:text-red-600' : 'text-white hover:text-red-200'
                }`}
              >
                {t('nav.pricing')}
              </button>
              <button
                onClick={() => scrollToSection('contact')}
                className={`text-sm font-medium transition-colors text-left py-2 whitespace-nowrap ${
                  isScrolled ? 'text-gray-700 hover:text-red-600' : 'text-white hover:text-red-200'
                }`}
              >
                {t('nav.contact')}
              </button>
              <button
                onClick={() => scrollToSection('order')}
                className="bg-red-600 text-white px-6 py-2 rounded-full text-sm font-medium hover:bg-red-700 transition-colors whitespace-nowrap text-center"
              >
                {t('nav.orderNow')}
              </button>
            </div>
          </div>
        )}
      </div>
    </nav>
  );
}
